import React, { Component } from 'react';
import { Modal, Button, Input } from 'antd';
import TableC from '../../basicElement/TableC';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class PreviewModal extends Component {
    state = {
        visible: false,
        loading: false,
        data: [],
        pagination: {},
    }

    show = record => {
        const pagination = {
            pageSize: 5,
            current: 1,
        };
        const searchParam = {
            keyword: '',
            userId: record.userId,
            hospitalName: record.hospitalName,
            departmentName: record.departmentName,
            userCompellation: record.userCompellation,
        };

        this.setState({
            data: [],
            pagination,
            searchParam,
            visible: true,
            data: [],
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    loadData = () => {
        this.setState({ loading: true });
        const { pagination, searchParam } = this.state;
        const { current, pageSize } = pagination;
        const { investigationAreaId, diseaseId, lineOfBusiness, secondLineName } = this.props.params;
        const options = {
            method: 'POST',
            url: API_URL.hospital.queryInvesByDoctorUserId,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParam,
                diseaseId,
                investigationAreaId,
                lineOfBusiness,
                secondLineName,
            },
            dataType: 'json',
            doneResult: data => {
                pagination.total = data.totalCount;
                this.setState({
                    data: data.datas,
                    loading: false,
                    pagination,
                });
            }
        }
        $.sendRequest(options)
    }

    handleChange = (field, e) => {
        const { searchParam } = this.state;
        searchParam[field] = e.target.value
        this.setState({ searchParam });
    }

    search = () => {
        this.loadData();
    }

    enterSearch = e => {
        if (e.charCode === 13) {
            this.search();
        }
    }

    getColumns = () => [{
        title: '序号',
        dataIndex: 'index',
        key: 'index',
        width: 60,
    }, {
        title: 'JDE主项目号',
        dataIndex: 'investigationJdeContractCode',
        key: 'investigationJdeContractCode',
        width: 100,
    }, {
        title: '项目简称',
        dataIndex: 'investigationName',
        key: 'investigationName',
        width: 240,
    }, {
        title: '项目编号',
        dataIndex: 'investigationCode',
        key: 'investigationCode',
        width: 100,
    }, {
        title: '业务线',
        dataIndex: 'lineOfBusinessString',
        key: 'lineOfBusinessString',
        width: 80,
    }, {
        title: '执行业务线二级分类',
        dataIndex: 'secondLineNames',
        key: 'secondLineNames',
        width: 100,
    }, {
        title: '区域',
        dataIndex: 'areaName',
        key: 'areaName',
        width: 90,
    }, {
        title: '城市',
        dataIndex: 'cityName',
        key: 'cityName',
        width: 90,
    }, {
        title: '医院主管姓名',
        dataIndex: 'directorUserCompellation',
        key: 'directorUserCompellation',
        width: 100,
    }, {
        title: '医院主管工号',
        dataIndex: 'directorEmployeeCode',
        key: 'directorEmployeeCode',
        width: 100,
    }, , {
        title: '医院主管上级姓名',
        dataIndex: 'directorLeaderUserCompellation',
        key: 'directorLeaderUserCompellation',
        width: 100,
    }, {
        title: '医院主管上级工号',
        dataIndex: 'directorLeaderEmployeeCode',
        key: 'directorLeaderEmployeeCode',
        width: 100,
    },{
        title: '项目领域',
        dataIndex: 'investigationAreaName',
        key: 'investigationAreaName',
        width: 120,
    }, {
        title: '疾病',
        dataIndex: 'diseaseName',
        key: 'diseaseName',
        width: 90,
    }, {
        title: '领域leader',
        dataIndex: 'leaderNameCode',
        key: 'leaderNameCode',
        width: 100,
    }, {
        title: '项目阶段',
        dataIndex: 'typeValue',
        key: 'typeValue',
        width: 90,
    }, {
        title: '临床项目身份',
        dataIndex: 'identityName',
        key: 'identityName',
        width: 100,
    }, {
        title: 'PM',
        dataIndex: 'pmUsers',
        key: 'pmUsers',
        width: 90,
    }, {
        title: 'CRC',
        dataIndex: 'crcName',
        key: 'crcName',
        width: 90,
    }]

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.search();
        });
    }

    render() {
        const { visible, loading, data, pagination, searchParam = {} } = this.state;
        const { keyword, hospitalName, departmentName, userCompellation } = searchParam;
        return (
            <Modal
                title="项目明细"
                visible={visible}
                onCancel={this.hide}
                className="preview-modal"
                width="1070px"
                bodyStyle={{ maxHeight: 700 }}
                footer={<Button type="ghost" onClick={this.hide}>关闭</Button>}
            >
                <div style={{ background: '#fff', padding: '10px 30px' }}>
                    <div className="filter-bar">
                        <div className="filter-bar-investigation" style={{ width: '100%' }}>
                            <h3 style={{ float: 'left' }}>医生姓名：{userCompellation} <span className="ant-divider" />  所在医院：{hospitalName} <span className="ant-divider" /> 所在科室：{departmentName} </h3>
                        </div>
                        <div className="filter-bar-investigation" style={{ width: '100%' }}>
                            <div className="form-item" style={{ float: 'right' }}>
                                <label htmlFor="" className="ui-label">项目编号 / 项目简称</label>
                                <Input
                                    placeholder="请输入项目编号"
                                    onChange={this.handleChange.bind(this, 'keyword')}
                                    onKeyPress={this.enterSearch}
                                    value={keyword}
                                />
                                <Button type="primary" icon="search" onClick={this.search}>搜索</Button>
                            </div>
                        </div>
                    </div>
                    <TableC
                        columns={this.getColumns()}
                        data={data}
                        loading={loading}
                        className="previewModal"
                        onChange={this.handleTableChange}
                        scrollY={400}
                        pagination={pagination}
                    />
                </div>
            </Modal>
        );
    }
}

export default PreviewModal;



// WEBPACK FOOTER //
// ./src/components/hospital/doctorInfo/PreviewModal.js